import { timeFormat } from 'd3';
import { LwGeneralGraph } from './general-graph';
import { TimeSeriesDataArray } from '../../interfaces/time-series-data';
import { SDSuperChart, SDLine, VLine } from '@lightwaverf/simple-d3-graph';
import { time } from '../../services/global-variables.service';

export const compareFunc = function (a, b) {
    if (a.timestamp < b.timestamp) {
        return 1;
    }
    if (a.timestamp > b.timestamp) {
        return -1;
    }
    // a must be equal to b
    return 0;
};

/** add an end value for output */
export let addlastValue = (data) => {
    if (!data.length) {
        return data = [{
            timestamp: Date.now(),
            value: 0
        }, {
            timestamp: Date.now() - time.week,
            value: 0
        }];
    }
    data.push({
        timestamp: Date.now(),
        value: data[data.length - 1].value
    });
};

export const heatingDataProcess = function (data, features) {
    for (let index = 0; index < features.length; index++) {
        addlastValue(data[index]);
    }
};



export class LwHeatingExternalGraph extends LwGeneralGraph {
    width: number;
    graph: SDSuperChart;
    miniGraph: SDSuperChart;
    constructor(element: any, miniGraphEle: HTMLElement) {
        super(element);
        this.miniGraph = new SDSuperChart(miniGraphEle);
    }

    draw(data: TimeSeriesDataArray[], features) {
        
        this.graph = new SDSuperChart(this.element);
        heatingDataProcess(data, features);
        let mainGraphDatas = [];
        let outputGraphDatas = [];
        for (let index = 0; index < features.length; index++) {
            const element = features[index];
            if (element.attributes.type === 'temperature' && element.attributes.channel === 0) {
                data[index] = data[index].map((d) => {
                    d.value = d.value / 10;
                    return d;
                });
                mainGraphDatas[0] = {
                    data: data[index],
                    options: {},
                    appearance:
                    {
                        color: 'red',
                        shape: 'special-line',
                        format: 'iso',
                        curveType: 'linear',
                        coordinateMoveFunc: false
                    }
                };
            } else if (element.attributes.type === 'temperature' && element.attributes.channel === 1) {
                data[index] = data[index].map((d) => {
                    d.value = d.value / 10;
                    return d;
                });
                mainGraphDatas[1] = {
                    data: data[index],
                    options: {},
                    appearance:
                    {
                        color: '#0E8E75',
                        shape: 'special-line',
                        format: 'iso',
                        curveType: 'linear',
                        coordinateMoveFunc: false
                    }
                };
            } else if (element.attributes.type === 'valveLevel') {
                outputGraphDatas = [{
                    data: data[index],
                    options: {},
                    appearance:
                    {
                        color: '#ff7f0e',
                        opacity: 0.8,
                        shape: 'area',
                        format: 'iso',
                        animation: false,
                        curveType: 'stepAfter',
                        coordinateMoveFunc: true
                    }
                }];
            }

        }

        this.graph.draw(mainGraphDatas, {
            chartArea: {
                height: 254
            },
            axis: { x: { scaleType: 'time' }, y: { title: 'Temperature (˚C)', domain: [-20, 40] } },
            explorer: { brush: true, coordinates: true }
        });

        this.miniGraph.draw(outputGraphDatas, {
            chartArea: {
                height: 200,
            },
            axis: {
                x: {
                    scaleType: 'time'
                },
                y: {
                    paddingTop: 0.1,
                    paddingBottom: 0,
                    unit: '%',
                    title: 'Output',
                    domain: [0, 120]
                }
            },
            explorer: {
                tooltip: 'special-tooltip',
                brush: true,
                coordinates: 'v-line'
            }
        });

        this.addHoverEffects();
        this.addBrushEffects();

    }

    private addBrushEffects() {
        this.graph.brush.addBrushListener((domain: any) => {
            this.miniGraph.x.redraw(domain);
            this.miniGraph.series[0].rescale();
        }, () => {
            this.miniGraph.x.redraw(this.miniGraph.x.originalDomain);
            this.miniGraph.series[0].rescale();
        });
    }

    private addHoverEffects() {


        this.graph.coordinates.addOverlayMouseInFunc(() => {
            this.miniGraph.coordinates.show();
            this.miniGraph.tooltip.show();
        });
        this.graph.coordinates.addOverlayMouseOutFunc(() => {
            this.miniGraph.coordinates.hide();
            this.miniGraph.tooltip.hide();
        });
        this.graph.series[0].addCoordinatorMoveFunc((mouseCoord: any) => {
            const dataPoint = (this.graph.series[0] as SDLine).findDataPoint(mouseCoord, true);
            const { x, y, value, x0 } = dataPoint;

            (this.graph.series[0] as SDLine).selectionCircle
                .attr('visibility', 'visible')
                .attr('cx', x)
                .attr('cy', y);

            const { value: value1 } = (this.graph.series[1] as SDLine).findDataPoint([x, y]);

            let tooltip = `
                <div class="tooltip-text title">${timeFormat('%Y-%m-%dT%H:%M:%S%Z')(this.graph.data[0].raw[value].timestamp)}</div>
                <div class="tooltip-text item">
                    <span class="dot" style="background-color:${this.graph.series[0].color}"></span>
                    <span class="sd-flex">Main: ${this.graph.data[0].raw[value].value} ˚C</span>
                </div>
                <div class="tooltip-text item">
                    <span class="dot" style="background-color:${this.graph.series[1].color}"></span>
                    <span class="sd-flex">External: ${this.graph.data[1].raw[value1].value} ˚C</span>
                </div>
            `;

            this.graph.tooltip.html(tooltip)
                .move(x, 30)
                .show();

        });
    }
}
